import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPenNew = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.4998 5.4997L18.3282 8.32812M3 20.9995L3.04745 20.6673C3.21536 19.4919 3.29932 18.9042 3.49029 18.3556C3.65975 17.8687 3.89124 17.4057 4.17906 16.978C4.50341 16.496 4.92319 16.0763 5.76274 15.2367L17.4107 3.58872C18.1918 2.80767 19.4581 2.80767 20.2392 3.58872C21.0202 4.36976 21.0202 5.63609 20.2392 6.41714L8.37744 18.2789C7.61579 19.0405 7.23497 19.4213 6.8012 19.7242C6.41618 19.993 6.00093 20.2157 5.56398 20.3877C5.07171 20.5814 4.54375 20.688 3.48793 20.901L3 20.9995Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPenNew;
